var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

Curriculog.ProposalForm.SmartfieldField = (function ($, _, Backbone, SmartfieldField) {

	SmartfieldField = Curriculog.ProposalForm.Field.extend({
		modelClass: Curriculog.ProposalForm.SmartFieldModel,

		initialize: function() {
			Curriculog.ProposalForm.Field.prototype.initialize.apply(this, arguments);

			// For unlaunched proposals that are loaded with fields in edit mode.
			this.isLoading = false;
			if (this.mode == 'edit') {
				this.isLoading = true;
				this.loadDataset();
			}
		},

		/**
		 * initializes select2
		 *
		 * @returns {promise}
		 */
		render: function() {
			this.setElement($('.field-' + this.model.id));
			this._unsaved_changes = false;
			return this.initSelect2().promise();
		},

		/**
		 * Used to return the value of the field
		 *
		 * @returns {String} - A JSON string.
		 */
		getValue: function() {
			/*
				Smartfield values are currently json with three keys:
				id, name, parent. Parent is only used by hierarchy.

				select2 plugin returns a list of ids, but legacy code expects
				json, so we patch it here. If we update the smartfield values
				and tracking, we can use val() instead.
			*/
			var $input = this.getInput(),
				value = $input.val(),
				that = this;

			if (value === null || value === '') {
				return '[]';
			}

			return JSON.stringify($.map(value, function(id, index) {
				return {
					id: id,
					name: $input.find('option[value="' + id + '"]:first').text().trim(),
					parent: 0
				};
			}));

		},

		/**
         * Parses the JSON value of the smarfield and returns a space separated string of values
         *
         * @returns {String}
         */
        getDisplayValue: function() {
            var value = this.getValue();

            if (!value) {
                return '';
            }

            value = JSON.parse(value);
            return _.pluck(value, 'name').join(' ');
        },

		/**
		 * Generates Select2 config options
		 *
		 * @returns {Object} Select2 config options
		 */
		getConfig: function() {
			var maxLength = this.model.get('maxLength');
			var config = {
				theme: 'curriculog',
				disabled: true,
				placeholder: 'Select an option',
				allowClear: false,
				// templateResult: this.renderEntityOption,
				maximumSelectionLength: maxLength > 0 ? 1 : 0
			};

			// For unlaunched proposals, we quietly load the dataset in the background.
			if (this.isLoading) {
				config.language = {
					noResults: function() {return "Loading Dataset...";}
				};
				config.placeholder = "Loading Dataset...";
			}

			if (this.mode == 'edit') {
				config.disabled = false;
			}

			if (this.datasetName == 'Entities') {
				config.templateResult = _.bind(this.renderEntityOption, this);
			}

			return config;
		},

		/**
		 * Initializes select2 on the field and binds the selection events
		 *
		 * @param   {Object} options - Give to override or add to the default options.
		 * @returns {Element}        - The original select field
		 */
		initSelect2: function(options) {
			var config = _.extend({}, this.getConfig(), options),
				$field = this.getInput();

			// Unbind all event handlers and kill any pre-existing instance
			this.destroySelect2();

			// Reinit select2 with new config
			$field.selectWoo(config);
			$field.on("select2:select", _.bind(this.onSelect, this));
			$field.on("select2:unselect", _.bind(this.onUnselect, this));
			$field.on("select2:selecting", _.bind(this.onSelecting, this));
			$field.on("select2:opening", _.bind(this.onOpening, this));

			// SelectWoo Select2 Fork - change type from text to search for styling
			$field.next().find('.select2-search__field').attr('type', 'search')
				.attr('aria-describedby', $field[0].id + '-label').attr('aria-live', 'off');
			// SelectWoo: stop screen reader from reading selection so we can use custom
			// announcements
			$field.next().find('.select2-selection__rendered').attr('aria-live', null)
				.attr('aria-relevant', null).attr('aria-atomic', null);

			Backbone.trigger('form:stretch');
			return $field;
		},

		/**
		 * Used to determine if the field is editable
		 *
		 * @returns {Boolean}
		 */
		isEditable: function() {
			// if field is entity field, return false, so edit exits
			// else return true to allow editing on field
			var systemRequired = this.model.get('systemRequired'),
				proposalStatus = this.proposal.get('status');

			if ((systemRequired == 'proposalEntity') && (proposalStatus != 'unlaunched')) {
				return false;
			}

			return Curriculog.ProposalForm.Field.prototype.isEditable.apply(this, arguments);
		},

		/**
		 * Reloads the steps tab when the entity has changed
		 */
		afterSave: function() {
			// this.$('#'+this.model.id).val(this.model.get('value'));
			if (this.model.get('systemRequired') == 'proposalEntity') {
				// proposalObject.ajaxTab('history');
				proposalObject.getUsers();
			}
			return Curriculog.ProposalForm.Field.prototype.afterSave.apply(this, arguments);
		},

		/**
		 * Reloads the smartfields values after save
		 *
		 * @returns {promise}
		 */
		afterEdit: function() {
			var promise = this.loadDataset();
			return $.when(promise, Curriculog.ProposalForm.Field.prototype.afterEdit.call(this));
		},

		/**
		 * Loads in the fields dataset and then re-renders the smartfield
		 *
		 * @returns {Promise}
		 */
		loadDataset: function() {
			var $field = this.getInput(),
				that = this,
				fieldDataset = this.model.get('dataset');

			this.datasetName = fieldDataset.charAt(0).toUpperCase() + fieldDataset.slice(1);

			this.addMask(this.$el, "Loading Field");

			// Destroy the prior select2 prior to initing a new one
			this.destroySelect2();

			// Because of the children in the dataset and the existence of the Hierarchy
			// Dropdown view, we handle entities differently
			if (this.datasetName === 'Entities') {
				return this.getEntityDropdown();
			}

			return $.ajax({
				url: '/smartfield/dataset.json',
				type: 'GET',
				data: {
					name: this.datasetName
				},
				success: function(results) {
					var dataset = _.map(results.data, function(item, index) {
						return {
							id: item.id,
							text: item.name
						};
					});

					that.isLoading = false;
					that.initSelect2({
						data: dataset
					});
				}
			});

		},

		/**
		 * MASSIVE TERRIBLE SHORTCUT HACK to disable the conflict dialog
		 *
		 */
		showConflict: function(data) {
			return false;
			// Oh writing this feels nasty. TP: 9214
		},

		/**
		 * Returns the rendered html element of an item in the select2 dropdown
		 *
		 * @param   {Object} item
		 * @returns {Element}
		 */
		renderEntityOption: function(item, container) {
			var originalOption = $(item.element),
				classes = originalOption.attr('class') || '';

			// The container doesnt actually exist at this point but they give
			// us a reference to it ??? _.defer adding classes to it so it
			// actually exists when we modify it.
			_.defer(function(){
				$(container).addClass(classes);
			});

			item.depth = originalOption ? Number(originalOption.data('depth')) : 0;
			item.padding = item.depth * 20;

			return $(nunjucks.render('ProposalForm/Form/smartfieldDropdownItem.html', item));
		},

		/**
		 * Populates the <select> field on the page then instantiates select2 on it.
		 *
		 * @param   {Object} hierarchy_data
		 */
		renderEntityDropdown: function(hierarchy_data) {
			var $field = this.getInput(),
				elementID = this.model.id,
				value = this.model.get('value'),
				maxLength = this.model.get('maxLength'),
				entities = new Curriculog.Entities(),
				relationships = new Curriculog.EntityRelationships();

			// init collections
			entities.reset(hierarchy_data.entities);
			relationships.reset(hierarchy_data.relationships);

			// init hierarchy dropdown view
			var entityDropdown = new Curriculog.ProposalForm.ProposalEntityDropdownView({
				collection: relationships,
				entities: entities,
				ineligible: [],
				noAvailableOptionsMessage: 'No eligible entities available',
				id: elementID,
				attributes: {
					name: 'parents'
				}
			});

			// replace existing select
			$field.html(entityDropdown.$el.html());

			// reselect previously selected options, first disabling all
			// selected items (for duplicated hierarchy items) and then
			// selecting and enabling the first instance of the item only
			if (value !== '') {
				value = JSON.parse(value);
				_.each(value, function(item, index) {
					var $options = $field.find('option[value="' + item.id + '"]');

					// $options.prop('disabled', 'disabled');
					$options.first().prop('selected', 'selected');
						// .prop('disabled', false)
					$options.addClass('duplicate-selected');
				});
			}
			this.isLoading = false;
			this.initSelect2();
		},

		/**
		 * Fired when an item is selected, faux selects duplicates.
		 *
		 * @param   {Event} event
		 */
		onSelect: function(event) {
			var $field = this.getInput(),
				id = event.params.data.id,
				$options = $field.find('option[value="' + id + '"]');

				var action = 'Deselected';
				if ( event.params.data.selected === true ){
					action = 'Selected';
				}

				var idName = 'sf-' + event.timeStamp;
				setTimeout(function(){
					$('<p aria-live="assertive" role="dialog" id="' + idName + '" class="screen-reader-text"/>').appendTo('body');
					$('#' + idName).text(action + ': ' + event.params.data.text).focus();
					setTimeout(function(){
						$('#' + idName).detach();
					}, 3000);
				}, 300);

			$options.toggleClass('duplicate-selected');

			Backbone.trigger('form:stretch');

		},

		/** Alias to onSelect. Can be overridden. */
		onUnselect: function(event) {

			if (!event.params.originalEvent) {
				return;
			}

			event.params.originalEvent.stopPropagation();

			this.onSelect.apply(this, arguments);
		},

		/**
		 * Prevents a duplicate item from being selected twice.
		 *
		 * @param   {Event} event
		 * @returns {Boolean} - Controls whether or not the item will be selected.
		 */
		onSelecting: function(event) {
			var $field = this.getInput(),
				values = $field.val() || [],
				id = event.params.args.data.id,
				$options = $field.find('option[value="'+ id +'"]'),
				selectingDupe = values.indexOf(id) > -1;

			if (! selectingDupe) {
				return true;
			}

			this.stopEvent();

			// The clicked option is already faux selected so lets unselect it and the original.
			$field.selectWoo('destroy');
			$options.prop('selected', false);
			$options.removeClass('duplicate-selected');
			this.initSelect2();

			return false;
		},

		/**
		 * Prevent the enter key from opening the field when in view only mode
		 *
		 * @param   {Event} event
		 */
		onOpening: function(event) {
			if (! this.isEditable() || ! this.userPermissions.canEdit) {
				this.stopEvent();
				return false;
			}
		},

		/**
		 * Loads the entities dataset from the server
		 *
		 * @returns {promise}
		 */
		getEntityDropdown: function() {
			// get the data and replace the existing select
			return $.ajax({
				url: '/rest/hierarchylist.json',
				type: 'GET',
				context: this,
				success: this.renderEntityDropdown
			});

		},

		/**
		 * Destroy handler for smartfields
		 *
		 * @returns {Promise}
		 */
		destroy: function() {
			this.destroySelect2();
			return $.when();
		},

		/**
		 * Unbinds the select2 events and destroys any existing select2 instance
		 */
		destroySelect2: function() {
			var $field = this.getInput();

			$field.off("select2:select");
			$field.off("select2:opening");
			$field.off("select2:unselect");
			$field.off("select2:selecting");
			$field.off("select2:unselect");

			if ($field.data('select2')) {
				$field.selectWoo('destroy');
			}
		}

	});

	return SmartfieldField;

})($, _, Backbone, Curriculog.ProposalForm.SmartfieldField || {});
